import React, { ReactNode, useState } from 'react'
import { ParseKeys } from 'i18next'
import { useTranslation } from 'next-i18next'
import { UnprocessableContentError } from 'shared/errors/unprocessable-content-error'
import { BadRequest } from '../errors/bad-request'
import { InternalError } from '../errors/internal-error'
import { PrimaryButton, SecondaryButton } from './button'
import Modal from './modal'

// TODO: /src/modules/course/components/course-lecture-assignment/submit-assignment-modal.tsx
type ConfirmationProps = {
  onCloseModal: () => void
  onConfirm: () => void
  title?: ParseKeys
  confirmationContent?: React.ReactNode
  errorMessageMap?: Partial<Record<'internalError' | 'unprocessableContentError', ParseKeys>>
}

function Confirmation({
  onCloseModal,
  onConfirm,
  title = 'confirmation_modal.default_title',
  confirmationContent = '',
  errorMessageMap,
}: ConfirmationProps): ReactNode {
  const { t } = useTranslation()
  const [opened, setOpened] = useState(true)
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  function closeModal(): void {
    setOpened(false)
    onCloseModal()
  }

  // TODO: move to tanstack
  const handleConfirm = async (): Promise<void> => {
    try {
      setIsLoading(true)
      onConfirm()
      setOpened(false)
    } catch (error_) {
      if (error_ instanceof BadRequest && error_.errors.common) {
        setError(error_.errors.common.join(''))
      } else if (
        error_ instanceof UnprocessableContentError &&
        errorMessageMap?.unprocessableContentError
      ) {
        setError(t(errorMessageMap.unprocessableContentError))
      } else if (error_ instanceof InternalError) {
        setError(t(errorMessageMap?.internalError ?? 'core.error.internal_error_message'))
      }
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Modal opened={opened} onClose={closeModal} title={t(title)} small>
      <div className="mb-6 flex justify-center">{confirmationContent}</div>
      <div className="mb-6 flex justify-center gap-4">
        <PrimaryButton className="ml-5 p-1 px-7" onClick={handleConfirm} isLoading={isLoading}>
          {t('confirmation_modal.confirm')}
        </PrimaryButton>
        <SecondaryButton className="px-7" onClick={onCloseModal}>
          {t('confirmation_modal.cancel')}
        </SecondaryButton>
      </div>
      {error && <p className="mt-2 text-center text-sm text-red">{error}</p>}
    </Modal>
  )
}

export default Confirmation
